import dayjs, { type Dayjs, type OpUnitType } from 'dayjs'

declare module 'dayjs' {
  interface Dayjs {
    endOfUTC(unit: OpUnitType): Dayjs

    period(interval: number, unit: ManipulateType, endDate: Dayjs): Dayjs[]
  }
}

export default defineNuxtPlugin(() => {
  dayjs.extend((_option, dayjsClass, _dayjsFactory) => {
    dayjsClass.prototype.endOfUTC = function (unit: OpUnitType) {
      return this.endOf(unit).startOf('day')
    }

    dayjsClass.prototype.period = function (interval, unit, endDate) {
      let currentDate = this.clone()
      const result: Dayjs[] = [currentDate.clone()]

      while (currentDate.isBefore(endDate, unit)) {
        currentDate = currentDate.add(interval, unit)
        result.push(currentDate.clone())
      }

      return result
    }
  })
})
